import React from "react";
import { ThemeProvider } from "@mui/material";
import theme from "./Config/theme";
import AppRoutes from "./Router/AppRoutes";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppRoutes />
    </ThemeProvider>
  );
}

export default App;
